import store from "@/store";
export default function (can, cannot) {
  can("view-menu", "select-group");
  can("view-menu", "Infor");
  if (store.getters["Auth/isPrivateUsingGroup"]) {
    can("view-menu", "Member");
  }
  can("view-menu", "Blog");
  can("view-menu", "Album");
  can("view-menu", "File");
}
